export default "__VITE_ASSET__XPvdLKlw__"